export const shouldPreventInteractOutside = (
  closeOnInteractOutside = false
): boolean => !closeOnInteractOutside;
